import angular from 'angular';

import { HomeView } from '@/react/portainer/HomeView';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { r2a } from '@/react-tools/react2angular';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { CreateUserAccessToken } from '@/react/portainer/account/CreateUserAccessTokenView';
import { EdgeComputeSettingsView } from '@/react/portainer/settings/EdgeComputeView/EdgeComputeSettingsView';
import { InitEdgeView } from '@/react/portainer/init/InitEdgeView/InitEdgeView';
import { CloudView } from '@/react/portainer/settings/sharedCredentials/CloudView';
import { CreateCredentialView } from '@/react/portainer/settings/sharedCredentials/CreateCredentialsView';
import { EditCredentialView } from '@/react/portainer/settings/sharedCredentials/EditCredentialView';
import { NotificationsView } from '@/react/portainer/notifications/NotificationsView';
import { CreateView as licenseCreateView } from '@/react/portainer/licenses/CreateView/CreateView';
import { SettingsView } from '@/react/portainer/settings/SettingsView/SettingsView';
import { CreateHelmRepositoriesView } from '@/react/portainer/account/helm-repositories/CreateHelmRepositoryView';
import { AlertingView } from '@/react/portainer/observability/AlertsView/AlertsView';
import { ListView as PoliciesListView } from '@/react/portainer/policies/ListView/ListView';
import { PolicyDetailView } from '@/react/portainer/policies/DetailView/PolicyDetailView';
import { PolicyCreateView } from '@/react/portainer/policies/CreateView/PolicyCreateView';
import { AlertRuleDetails } from '@/react/portainer/observability/AlertsView/AlertRuleEdit/AlertRuleDetails';
import { RecommendationsView } from '@/react/portainer/recommendations/RecommendationsView';
import { GlobalScopedKubeconfigsView } from '@/react/portainer/scoped-kubeconfigs/GlobalScopedKubeconfigsView';
import { ListView as AddonsListView } from '@/react/portainer/addons/ListView/ListView';
import { AddonDetailView } from '@/react/portainer/addons/DetailView/AddonDetailView';
import { AddonInstallView } from '@/react/portainer/addons/InstallView/AddonInstallView';
import { NoAddonAccessView } from '@/react/portainer/addons/NoAddonAccessView/NoAddonAccessView';

import { wizardModule } from './wizard';
import { teamsModule } from './teams';
import { updateSchedulesModule } from './update-schedules';
import { accountViews } from './account';
import { environmentGroupModule } from './env-groups';
import { registriesModule } from './registries';
import { activityLogsModule } from './activity-logs';
import { templatesModule } from './templates';
import { usersModule } from './users';
import { environmentsModule } from './environments';
import { gitopsViewsModule } from './gitops';
import { authModule } from './auth';

export const viewsModule = angular
  .module('portainer.app.react.views', [
    authModule,
    wizardModule,
    teamsModule,
    updateSchedulesModule,
    accountViews,
    environmentGroupModule,
    registriesModule,
    activityLogsModule,
    templatesModule,
    usersModule,
    environmentsModule,
    gitopsViewsModule,
  ])
  .component(
    'homeView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(HomeView))), [])
  )

  .component(
    'createUserAccessToken',
    r2a(
      withReactQuery(withCurrentUser(withUIRouter(CreateUserAccessToken))),
      []
    )
  )
  .component(
    'settingsEdgeCompute',
    r2a(
      withUIRouter(withReactQuery(withCurrentUser(EdgeComputeSettingsView))),
      ['onSubmit', 'settings']
    )
  )
  .component(
    'initEdgeView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(InitEdgeView))), [])
  )
  .component(
    'settingsSharedCredentialsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(CloudView))), [])
  )
  .component(
    'addSharedCredentialsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(CreateCredentialView))), [])
  )
  .component(
    'editSharedCredentialsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(EditCredentialView))), [])
  )
  .component(
    'notifications',
    r2a(withUIRouter(withReactQuery(withCurrentUser(NotificationsView))), [])
  )

  .component(
    'settingsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(SettingsView))), [])
  )
  .component(
    'alertsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(AlertingView))), [])
  )
  .component(
    'alertsRuleView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(AlertRuleDetails))), [])
  )
  .component(
    'licenseCreateView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(licenseCreateView))), [])
  )
  .component(
    'createHelmRepositoryView',
    r2a(
      withUIRouter(withReactQuery(withCurrentUser(CreateHelmRepositoriesView))),
      []
    )
  )
  .component(
    'policiesView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(PoliciesListView))), [])
  )
  .component(
    'policyCreateView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(PolicyCreateView))), [])
  )
  .component(
    'policyDetailView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(PolicyDetailView))), [])
  )
  .component(
    'recommendationsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(RecommendationsView))), [])
  )
  .component(
    'globalScopedKubeconfigsView',
    r2a(
      withUIRouter(
        withReactQuery(withCurrentUser(GlobalScopedKubeconfigsView))
      ),
      []
    )
  )
  .component(
    'addonsView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(AddonsListView))), [])
  )
  .component(
    'addonDetailView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(AddonDetailView))), [])
  )
  .component(
    'addonInstallView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(AddonInstallView))), [])
  )
  .component(
    'noAddonAccessView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(NoAddonAccessView))), [])
  ).name;
